import { onMounted } from "vue";
import {
    getBrowserType,
    getBrowserVersion,
    getDeviceType,
} from "@/utils/browser-detection";

declare global {
    interface Window {
        _genesysJs?: string;
        Genesys?: (...args: unknown[]) => void;
    }
}

function GenesysDbSet() {
    const attributes = {
        originUrl: window.location.origin,
        browserType: getBrowserType(),
        browserVersion: getBrowserVersion(),
        deviceType: getDeviceType(),
    };

    if (!window.Genesys) return;

    window.Genesys(
        "command",
        "Database.set",
        { messaging: { customAttributes: attributes } },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (data: any) {
            // eslint-disable-next-line no-console
            console.log("set fulfilled", data);
        },
        function () {
            // eslint-disable-next-line no-console
            console.log("set rejected");
        }
    );
}

export const useGenesys = () => {
    onMounted(() => {
        (function (
            g: Window & typeof globalThis & { [key: string]: any }, // eslint-disable-line @typescript-eslint/no-explicit-any
            e: string,
            n: string,
            es: any, // eslint-disable-line @typescript-eslint/no-explicit-any
            ys?: HTMLScriptElement
        ) {
            g._genesysJs = e;
            g[e] =
                g[e] ||
                function () {
                    (g[e].q = g[e].q || []).push(arguments);
                };
            g[e].t = 1 * Date.now();
            g[e].c = es;
            ys = document.createElement("script");
            ys.async = true;
            ys.src = n;
            ys.charset = "utf-8";
            document.head.appendChild(ys);
        })(
            window,
            "Genesys",
            "https://apps.euw2.pure.cloud/genesys-bootstrap/genesys.min.js",
            {
                environment: "prod-euw2",
                deploymentId: "c22ed8da-d3b2-4084-bb8b-0d96c95aa143",
            }
        );

        GenesysDbSet();

        if (!window.Genesys) return;

        window.Genesys("subscribe", "Conversations.opened", function () {
            GenesysDbSet();
        });
    });
};
